import { NavLink, useParams } from "react-router-dom";
import NoRights from "../Common/NoRights";
import "./DomainEmptyState.scss";
import React, { useState, useEffect, Fragment, useRef } from "react";
import { AsyncAjaxDelete, AsyncAjaxGet, AsyncAjaxPatch, AsyncAjaxPost, } from "../Common/AsyncAjaxService";
import { utils, ResponseCode, AddLogInAmplitude } from "../../utils/Utils";
import Leftpanel from "../../Layout/Sidebar/LeftPanel";
import Loader from "../Common/Loader";
import { useSelector } from 'react-redux'
import '../Zenswipe/zenswipe.js';
import Alert from "react-bootstrap/Alert";
import { useDispatch } from 'react-redux'
import useGenerateToken from "components/Hook/useGenerateToken";
import useSession from "components/Hook/useSession";
import {
     SuccessPurchaseDomain
} from '../Slice/Business';

const Checkout = (props) => {

     const { BusinessID, ReactBusinessId, ReactUserID, UserID, CurrencySymbol, WebsiteBuilderParentWebsite, IsViewAllowed, IsModifyAllowed, TaxPercentage, CountryID, BuildInDomain, VagaroURL, AmplitudeBusinessID } = useSelector((state) => state.Business);
     const dispatch = useDispatch();

     const params = useParams();

     const VagaroAPIEnum = {
          GetDomainCart: "merchants/" + BusinessID + "/domains/carts",
          DeleteDomainCart: "merchants/" + BusinessID + "/domains/carts",
          PurchaseDomain: "merchants/" + BusinessID + "/domains/purchase",
          GetOwnerCardDetails: BusinessID + "/zenswipe/getownercarddetails",
          CollectDomainPayment: BusinessID + "/zenswipe/collectdomainpayment",
          UpdateOwnerCardDetails: BusinessID + "/zenswipe/updateownercarddetails",
          SendMail: BusinessID + "/SendMail/sendDomainEmail",
          ConnectedDomain: "merchants/" + BusinessID + "/domains/",
          GetSession: "merchants/" + BusinessID + "/session",
          CheckDomainValidation: BusinessID + "/DomainProcess/checkdomainvalidation",
          CheckIPAddress: BusinessID + "/DomainProcess/checkipaddress",
     };

     const purchaseDomainList = useRef([]);
     const PuchasedSuccessDomainList = useRef([]);


     const [isFirstTime, setIsFirstTime] = useState(false);
     const [isLoading, setLoading] = useState(false);
     const [cartDomainList, setCartDomainList] = useState([]);
     const [taxamount, setTaxAmount] = useState(0);
     const [totalamount, setTotalAmount] = useState(0);
     const [isFinish, setFinish] = useState(false);
     const [showcc, setshowcc] = useState(false);
     const [subtotal, setsubtotal] = useState(0);
     const [ipAddress, setIPAddress] = useState('');
     const cardTokenDetails = useRef([]);
     const zenswipeTransaction = useRef("");
     const [isValidMerchant, setValidMerchant] = useState(false);

     const [isExistingCard, setisExistingCard] = useState(true);

     const [Message, setMessage] = useState("");
     const [variant, setVariant] = useState("success");


     const CheckSession = async () => {
          setLoading(true);
          return await useSession(dispatch, BusinessID, UserID, (data) => {
               setLoading(false);
               if (data == true) {
                    if (ReactBusinessId > 0) {
                         GetOwnerCard();
                    }
                    CheckLogin();
               }
          });
     }

     useEffect(() => {
          utils.SetPageTitle("Domain Checkout");
          CheckSession();
     }, [BusinessID]);

     useEffect(() => {
          fetch('https://geolocation-db.com/json/')
               .then(response => response.json())
               .then(data => {
                    setIPAddress(data.IPv4);
               })
               .catch(error => console.log(error));
     }, [])

     useEffect(() => {
          if (isFinish) {
               window.setTimeout(() => {
                    setFinish(false);
                    setLoading(false);
                    window.location.href = "/business/" + params.StyleId + "/" + params.LayoutId + "/domain";
               }, 3000)
          }
     }, [isFinish])

     const CheckLogin = () => {
          if (ReactBusinessId === -2) {
               window.location.replace(WebsiteBuilderParentWebsite + "login");
          }
          else {
               CheckDomainValidation();
          }
     }

     const CheckDomainValidation = async () => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               setLoading(true);
               await AsyncAjaxGet(
                    VagaroAPIEnum.CheckDomainValidation,
                    access_token,
                    function onSuccess(data) {
                         if (
                              data != null &&
                              data.data != null &&
                              data.data.responseCode == ResponseCode.Success
                         ) {
                              if (data != null && data.data != null && data.data.data != null && data.data.data == false) {
                                   setCartDomainList([]);
                                   utils.ShowAlert("Alert", "Please contact support!", "OpenDialog", true);                                 
                                   setTimeout(() => {
                                        window.location.href = "/business/" + params.StyleId + "/" + params.LayoutId + "/domain";
                                   }, 1000);
                              }
                              else {
                                   CheckIPAddress();
                              }
                         }
                         else {
                              CheckIPAddress();
                         }
                         setLoading(false);
                    },
                    function OnError() {
                         utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                         CheckIPAddress();
                    }
               );
          }
          else {
               utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     }

     const CheckIPAddress = async () => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               setLoading(true);
               await AsyncAjaxGet(
                    VagaroAPIEnum.CheckIPAddress,
                    access_token,
                    function onSuccess(data) {
                         if (
                              data != null &&
                              data.data != null &&
                              data.data.responseCode == ResponseCode.Success
                         ) {
                              if (data != null && data.data != null && data.data.data != null && data.data.data == false) {
                                   setCartDomainList([]);
                                   utils.ShowAlert("Alert", "Please contact support!", "OpenDialog", true);                                   
                                   setTimeout(() => {
                                        window.location.href = "/business/" + params.StyleId + "/" + params.LayoutId + "/domain";
                                   }, 1000);

                              }
                         }
                         setLoading(false);
                    },
                    function OnError() {
                         utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    }
               );
          }
          else {
               utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     }


     const GetCartDomainList = async (IsIFrameLoad) => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               setLoading(true);
               var GetDomainCartListAPI = typeof params.domainname != 'undefined' && params.domainname != null && params.domainname != "" ? VagaroAPIEnum.GetDomainCart + "/" + params.domainname : VagaroAPIEnum.GetDomainCart;
               await AsyncAjaxGet(
                    GetDomainCartListAPI,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null) {
                                        var cartdomain = data.data.data
                                        var filtercartdomain = cartdomain.filter(
                                             (col) => col.available === true
                                        );
                                        var total = 0;
                                        var taxcalc = 0;
                                        var totalpayment = 0;
                                        filtercartdomain.map((d) => {
                                             total = total + parseFloat(d.vagaroDomainCharge);
                                             taxcalc = (total * TaxPercentage) / 100;
                                             totalpayment = total + taxcalc;
                                        });
                                        setTaxAmount(taxcalc);
                                        setTotalAmount(totalpayment);
                                        setsubtotal(total);
                                        setCartDomainList(filtercartdomain);
                                        setLoading(false);
                                        setIsFirstTime(true);
                                        if (IsIFrameLoad) {
                                             GetCCIframe();
                                        }
                                   }
                                   else {
                                        setLoading(false);
                                        setIsFirstTime(true);
                                   }
                              }
                              else {
                                   setLoading(false);
                                   setIsFirstTime(true);
                              }
                         }
                         catch (error) {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get Cart Domain List",
                                   null,
                                   ""
                              );
                              utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                         }
                    },
                    function OnError() {
                         setLoading(false);
                         utils.appInsightTrack(
                              ReactBusinessId,
                              ReactUserID,
                              "Get Cart Domain List",
                              null,
                              ""
                         );
                         utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    }
               );
          }
          else {
               utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     }

     const GetOwnerCard = async () => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               setLoading(true);
               await AsyncAjaxPost(
                    VagaroAPIEnum.GetOwnerCardDetails,
                    null,
                    access_token,
                    function onSuccess(data) {
                         try {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   if (data != null && data.data != null && data.data.data != null) {
                                        cardTokenDetails.current = data.data.data;
                                        let isIFrameLoad = false;
                                        if (!utils.Validate(cardTokenDetails.current.cardTokenID)) {
                                             isIFrameLoad = true;
                                        }
                                        else {
                                             isIFrameLoad = false;
                                        }
                                        GetCartDomainList(isIFrameLoad);
                                   }
                                   else {
                                        setLoading(false);
                                        cardTokenDetails.current = [];
                                   }
                              }
                              else {
                                   setLoading(false);
                                   cardTokenDetails.current = [];
                              }
                         }
                         catch (error) {
                              setLoading(false);
                              cardTokenDetails.current = [];
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Get Cart Domain List",
                                   null,
                                   ""
                              );
                         }
                    },
                    function OnError() {
                         setLoading(false);
                         cardTokenDetails.current = [];
                         utils.appInsightTrack(
                              ReactBusinessId,
                              ReactUserID,
                              "Get Cart Domain List",
                              null,
                              ""
                         );
                    }
               );
          }
          else {
               utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
          }
     }


     const FormatPrice = (value) => {
          return (
               value.toLocaleString(undefined, {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
               })
          );
     };

     const DeleteDomainCart = async (domain, isBinding) => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Message", "Sorry, You don't have permission to delete domain.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    await AsyncAjaxDelete(
                         VagaroAPIEnum.DeleteDomainCart + "/" + domain + "/" + UserID,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (
                                        data != null &&
                                        data.data != null &&
                                        data.data.responseCode == ResponseCode.Success
                                   ) {
                                        if (data != null && data.data != null && data.data.data != null && data.data.data.status === true) {
                                             if (isBinding) {
                                                  GetCartDomainList(false);
                                             }
                                        }
                                        else {
                                             if (isBinding) {
                                                  setLoading(false);
                                             }
                                        }
                                   }
                                   else {
                                        if (isBinding) {
                                             setLoading(false);
                                        }
                                   }
                              }
                              catch (error) {
                                   if (isBinding) {
                                        setLoading(false);
                                   }
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Delete Domain Cart",
                                        null,
                                        ""
                                   );
                                   utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                              }
                         },
                         function OnError() {
                              if (isBinding) {
                                   setLoading(false);
                              }
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Delete Domain Cart",
                                   null,
                                   ""
                              );
                              utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     }

     const totalDomainCount = useRef(0);
     const [domainCount, setDomainCount] = useState(0);
     useEffect(() => {
          if (domainCount > 0 && domainCount <= totalDomainCount.current) {
               PurchaseDomain(domainCount);
          }
     }, [domainCount]);

     const ShowLoadingPanel = (FlgShow) => {
          setLoading(FlgShow);
     }

     const GetCCIframe = async () => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token) && (typeof cardTokenDetails.current != 'undefined' && cardTokenDetails.current != null && cardTokenDetails.current.merchantTokenID != null && cardTokenDetails.current.merchantTokenID != "")) {
               setLoading(true);
               setshowcc(true);
               window.vui.loader = ShowLoadingPanel;
               window.vui.getTypeFramewithCardOnFile("dvccframe", 450, cardTokenDetails.current.merchantTokenID, '100%', '', 1, 'React Domain', true, "0", "", access_token, BusinessID);
          }
          else {
               utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
          }
     };

     const AutoConnectDomain = async (domainName, access_token) => {

          if (!IsModifyAllowed) {
               utils.ShowAlert("Alert", "You do not have permission to connect domain.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    const Requestdata = {};
                    Requestdata.UserID = UserID;
                    await AsyncAjaxPatch(
                         VagaroAPIEnum.ConnectedDomain + domainName + "/connect",
                         Requestdata,
                         access_token,
                         function onSuccess(data) {
                         },
                         function OnError(error) {
                              if (error != undefined && error.response != undefined && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors.exception != undefined) {
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Connect Domain : " + error.response.data.errors.exception,
                                        domainName,
                                        ""
                                   );
                              }
                         }
                    );
               }
               else {
                    utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     }
     const PurchaseDomain = async (rnk) => {
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Message", "Sorry, You don't have permission to purchase domain.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    var FilterDomain = cartDomainList.filter(
                         (col) => col.id === rnk
                    );
                    if (FilterDomain.length === 1) {
                         setLoading(true);
                         const Requestdata = {};
                         Requestdata.DomainName = FilterDomain[0].domain;
                         Requestdata.PaymentID = zenswipeTransaction.current;
                         Requestdata.UserId = UserID;
                         Requestdata.IpAddress = ipAddress;
                         Requestdata.Amount = FilterDomain[0].vagaroDomainCharge;
                         Requestdata.TaxAmount = taxamount;
                         Requestdata.TotalAmount = totalamount;
                         Requestdata.CCNo = cardTokenDetails.current.creditCardNumber;
                         Requestdata.CurrencyCode = cardTokenDetails.current.currencyCode;
                         Requestdata.CurrencySymbol = CurrencySymbol;
                         Requestdata.MerchantTokenID = cardTokenDetails.current.merchantTokenID;
                         await AsyncAjaxPost(
                              VagaroAPIEnum.PurchaseDomain,
                              Requestdata,
                              access_token,
                              function onSuccess(data) {
                                   try {
                                        if (
                                             data != null &&
                                             data.data != null &&
                                             data.data.responseCode == ResponseCode.Success
                                        ) {
                                             if (data != null && data.data != null && data.data.data != null && data.data.data.status === true) {
                                                  DeleteDomainCart(Requestdata.DomainName, false);
                                                  AutoConnectDomain(Requestdata.DomainName, access_token);
                                             }
                                             const CheckoutResponse = {};
                                             CheckoutResponse.DomainName = FilterDomain[0].domain;
                                             CheckoutResponse.IsSuccess = true;
                                             CheckoutResponse.Reason = "Successful";
                                             CheckoutResponse.Message = "";
                                             purchaseDomainList.current.push(CheckoutResponse);

                                             const PDomain = {};
                                             PDomain.DomainName = FilterDomain[0].domain;
                                             PDomain.Price = FilterDomain[0].vagaroDomainCharge;
                                             PDomain.TaxAmount = taxamount;
                                             PDomain.TotalAmount = totalamount;
                                             PuchasedSuccessDomainList.current.push(PDomain);
                                        }
                                        if (rnk === totalDomainCount.current) {
                                             let domainsuccess = purchaseDomainList.current.filter(
                                                  (col) => col.IsSuccess === true
                                             );
                                             if (domainsuccess.length == 0) {
                                                  setMessage("Unable to complete domain purchase.");
                                                  setVariant("danger");
                                             }
                                             else {
                                                  if (purchaseDomainList.current.length == domainsuccess.length) {
                                                       setMessage("Website domain was purchased successfully. it will be ready to use in 5 to 10 min");
                                                       setVariant("success");
                                                  }
                                                  else {
                                                       setMessage("Website domain was partially purchased successfully. it will be ready to use in 5 to 10 min");
                                                       setVariant("success");
                                                  }
                                             }
                                             AmplitudeAfterDomainPurchase();
                                             DomainPurchasedEmail(access_token);
                                             setFinish(true);
                                             dispatch(SuccessPurchaseDomain());
                                        }
                                        else {
                                             setDomainCount(rnk + 1);
                                        }
                                   }
                                   catch (error) {
                                        const CheckoutResponse = {};
                                        CheckoutResponse.DomainName = Requestdata.DomainName;
                                        CheckoutResponse.IsSuccess = false;
                                        CheckoutResponse.Reason = "Reason Text Goes Here";
                                        CheckoutResponse.Message = "";
                                        purchaseDomainList.current.push(CheckoutResponse);
                                        if (rnk === totalDomainCount.current) {
                                             let domainsuccess = purchaseDomainList.current.filter(
                                                  (col) => col.IsSuccess === true
                                             );
                                             if (domainsuccess.length == 0) {
                                                  setMessage("Unable to complete domain purchase.");
                                                  setVariant("danger");
                                             }
                                             else {
                                                  if (purchaseDomainList.current.length == domainsuccess.length) {
                                                       setMessage("Website domain was purchased successfully.");
                                                       setVariant("success");
                                                  }
                                                  else {
                                                       setMessage("Website domain was partially purchased successfully.");
                                                       setVariant("success");
                                                  }
                                                  DomainPurchasedEmail(access_token);
                                             }
                                             setFinish(true);
                                        }
                                        else {
                                             setDomainCount(rnk + 1);
                                        }
                                        utils.appInsightTrack(
                                             ReactBusinessId,
                                             ReactUserID,
                                             "Domain Purchase Process",
                                             Requestdata.DomainName,
                                             ""
                                        );
                                   }
                              },
                              function OnError(error) {
                                   const CheckoutResponse = {};
                                   CheckoutResponse.DomainName = Requestdata.DomainName;
                                   CheckoutResponse.IsSuccess = false;
                                   CheckoutResponse.Reason = "Reason Text Goes Here";
                                   CheckoutResponse.Message = "";
                                   if (error != undefined && error.response != undefined && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors.exception != undefined) {
                                        CheckoutResponse.Message = error.response.data.errors.exception;
                                        purchaseDomainList.current.push(CheckoutResponse);
                                        utils.appInsightTrack(
                                             ReactBusinessId,
                                             ReactUserID,
                                             "purchase Domain : " + error.response.data.errors.exception,
                                             Requestdata.DomainName,
                                             ""
                                        );
                                   }
                                   else {
                                        purchaseDomainList.current.push(CheckoutResponse);
                                   }
                                   if (rnk === totalDomainCount.current) {
                                        let domainsuccess = purchaseDomainList.current.filter(
                                             (col) => col.IsSuccess === true
                                        );
                                        if (domainsuccess.length == 0) {
                                             setMessage("Unable to complete domain purchase.");
                                             setVariant("danger");
                                        }
                                        else {
                                             if (purchaseDomainList.current.length == domainsuccess.length) {
                                                  setMessage("Website domain was purchased successfully.");
                                                  setVariant("success");
                                             }
                                             else {
                                                  setMessage("Website domain was partially purchased successfully.");
                                                  setVariant("success");
                                             }
                                             DomainPurchasedEmail(access_token);
                                        }
                                        setFinish(true);
                                   }
                                   else {
                                        setDomainCount(rnk + 1);
                                   }
                              }
                         );
                    }
               }
               else {
                    utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
               }
          }
     }

     const AmplitudeAfterDomainPurchase = async () => {
          const access_token = await useGenerateToken(dispatch);
          var logobject = {};
          logobject.PageURL = window.location.href;
          logobject.Step = 27;
          logobject.UserAgent = (navigator.userAgent).toLowerCase();
          logobject.UserID = ReactUserID;
          logobject.BusinessID = AmplitudeBusinessID;
          logobject.MySiteURL = BuildInDomain + "/" + VagaroURL;
          logobject.CountryID = CountryID;
          logobject.accessToken = access_token;

          await AddLogInAmplitude(logobject);
     };

     const DomainPurchasedEmail = async (access_token) => {
          if (PuchasedSuccessDomainList.current.length > 0) {
               const Requestdata = {};
               Requestdata.PuchasedDate = new Date();
               let Price = 0;
               let Tax = 0;
               let Total = 0;
               const PuchasedDomainList = []
               PuchasedSuccessDomainList.current.map((d) => {
                    const DPurchase = {}
                    DPurchase.DomainName = d.DomainName;
                    DPurchase.Price = parseFloat(d.Price);
                    DPurchase.TaxAmount = parseFloat(d.TaxAmount);
                    DPurchase.TotalAmount = parseFloat(d.TotalAmount);
                    PuchasedDomainList.push(DPurchase);
                    Price = Price + DPurchase.Price;
                    Tax = Tax + DPurchase.TaxAmount;
                    Total = Total + DPurchase.TotalAmount;
               });
               Requestdata.PuchasedDomainList = PuchasedDomainList;
               Requestdata.Price = Price;
               Requestdata.Tax = Tax;
               Requestdata.Total = Total;
               Requestdata.CCType = cardTokenDetails.current.creditCardType;
               Requestdata.CCNumber = cardTokenDetails.current.creditCardNumber;
               Requestdata.CurrencySymbol = CurrencySymbol;
               if (utils.Validate(access_token)) {
                    setLoading(true);
                    await AsyncAjaxPost(
                         VagaroAPIEnum.SendMail,
                         Requestdata,
                         access_token,
                         function onSuccess(data) {
                              if (
                                   data != null &&
                                   data.data != null &&
                                   data.data.responseCode == ResponseCode.Success
                              ) {
                                   setLoading(false);
                              }
                              else {
                                   setLoading(false);
                              }
                         },
                         function OnError(error) {
                              setLoading(false);

                         }
                    );
               }
          }
     }

     const PurchaseDomainProcess = async () => {
          setDomainCount(0);
          totalDomainCount.current = cartDomainList.length;
          var rnk = 0;
          if (cartDomainList.length > 0) {
               cartDomainList.map((d) => {
                    rnk = rnk + 1;
                    d.id = rnk;
               });
               await PurchaseDomain(1);
          }
     }

     const UpdateOwnerCardDetails = async (ZenswipeResponse) => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               setLoading(true);
               const Requestdata = {};
               Requestdata.CardTokenID = ZenswipeResponse.card_token;
               Requestdata.CVV = ZenswipeResponse.cvv;
               Requestdata.CCFirstName = ZenswipeResponse.first_name;
               Requestdata.CCLastName = ZenswipeResponse.last_name;
               Requestdata.CreditCardType = ZenswipeResponse.cc_type;
               Requestdata.CreditCardNumber = ZenswipeResponse.cc_no;
               await AsyncAjaxPost(
                    VagaroAPIEnum.UpdateOwnerCardDetails,
                    Requestdata,
                    access_token,
                    function onSuccess(data) {
                         if (
                              data != null &&
                              data.data != null &&
                              data.data.responseCode == ResponseCode.Success
                         ) {
                              if (data != null && data.data != null && data.data.data != null && data.data.data === true) {
                                   try {
                                        let CardToken = [];
                                        CardToken.lBusinessID = ReactBusinessId;
                                        CardToken.cardTokenID = ZenswipeResponse.card_token;
                                        CardToken.cvv = ZenswipeResponse.cvv;
                                        CardToken.amount = totalamount;
                                        CardToken.currencyCode = cardTokenDetails.current.currencyCode;
                                        CardToken.currencySymbol = CurrencySymbol;
                                        CardToken.merchantTokenID = cardTokenDetails.current.merchantTokenID;
                                        CardToken.creditCardNumber = Requestdata.CreditCardNumber;
                                        CardToken.creditCardType = Requestdata.CreditCardType;
                                        cardTokenDetails.current = CardToken;
                                        DoPayment(false);
                                   }
                                   catch (error) {
                                        setLoading(false);
                                        utils.appInsightTrack(
                                             ReactBusinessId,
                                             ReactUserID,
                                             "Update Card Details",
                                             ReactBusinessId,
                                             ""
                                        );
                                   }
                              }
                              else {
                                   setLoading(false);
                              }
                         }
                         else {
                              setLoading(false);
                         }
                    },
                    function OnError(error) {
                         setLoading(false);
                         if (error != undefined && error.response != undefined && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors.exception != undefined) {
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Update Card Details",
                                   ReactBusinessId,
                                   ""
                              );
                              utils.ShowAlert("Warning", error.response.data.errors.exception, "OpenDialog");
                         }
                    }
               );
          }
          else {
               utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     }

     window.onGetTokenCallback = (res) => {
          if (res.data.custom_code == ResponseCode.Success) {
               setLoading(true);
               if (utils.Validate(res.data.data) && res.data.data.save_card === false) {
                    if (utils.Validate(res.data.data.card_token) && utils.Validate(res.data.data.cvv) && totalamount > 0
                         && utils.Validate(cardTokenDetails.current.currencyCode) && utils.Validate(cardTokenDetails.current.merchantTokenID)) {
                         let CardToken = [];
                         CardToken.lBusinessID = ReactBusinessId;
                         CardToken.cardTokenID = res.data.data.card_token;
                         CardToken.cvv = res.data.data.cvv;
                         CardToken.amount = totalamount;
                         CardToken.currencyCode = cardTokenDetails.current.currencyCode;
                         CardToken.currencySymbol = CurrencySymbol;
                         CardToken.merchantTokenID = cardTokenDetails.current.merchantTokenID;
                         CardToken.creditCardNumber = res.data.data.cc_no;
                         CardToken.creditCardType = res.data.data.cc_type;
                         cardTokenDetails.current = CardToken;
                         DoPayment(false);
                    }
                    else {
                         setLoading(false);
                    }
               }
               else {
                    setLoading(true);
                    if (utils.Validate(res.data.data) && res.data.data.save_card === true) {
                         UpdateOwnerCardDetails(res.data.data);
                    }
               }
          }
          else {
               setLoading(false);
               if (utils.Validate(res.data.Message)) {
                    utils.ShowAlert("Alert", res.data.Message, "OpenDialog1");
               }
          }
     }

     window.onRequiredCallback = (res) => {
          if (res.eventType === "required") {
               setLoading(false);
          }
     }

     const DoPayment = async (ischecked) => {
          const access_token = await useGenerateToken(dispatch);
          if (utils.Validate(access_token)) {
               if (cartDomainList.length > 0) {
                    if (showcc && ischecked) {
                         window.vui.frame.zenswipe.submit();
                         setLoading(false);
                         return;
                    }
                    setLoading(true);
                    const Requestdata = {};
                    Requestdata.cardTokenId = cardTokenDetails.current.cardTokenID;
                    Requestdata.cvv = cardTokenDetails.current.cvv;
                    Requestdata.amount = totalamount;
                    Requestdata.currencyCode = cardTokenDetails.current.currencyCode;
                    Requestdata.currencySymbol = CurrencySymbol;
                    Requestdata.merchant_token_id = cardTokenDetails.current.merchantTokenID;
                    await AsyncAjaxPost(
                         VagaroAPIEnum.CollectDomainPayment,
                         Requestdata,
                         access_token,
                         function onSuccess(data) {
                              try {
                                   if (data != null && data.data != null && data.data.CustomCode == ResponseCode.Success) {
                                        if (data != null && data.data != null && data.data.Data.customCode == ResponseCode.Success) {
                                             zenswipeTransaction.current = data.data.Data.transactionID;
                                             if (utils.Validate(zenswipeTransaction.current)) {
                                                  PurchaseDomainProcess();
                                             }
                                             else {
                                                  setLoading(false);
                                                  utils.ShowAlert("Alert", "Sorry, Your payment has been failed.", "OpenDialog");
                                             }
                                        }
                                        else {
                                             setLoading(false);
                                             utils.ShowAlert("Alert", data.data.Data.message, "OpenDialog");
                                        }
                                   }
                                   else {
                                        setLoading(false);
                                        utils.ShowAlert("Alert", "Sorry, Your payment has been failed.", "OpenDialog");
                                   }
                              } catch (error) {
                                   setLoading(false);
                                   utils.appInsightTrack(
                                        ReactBusinessId,
                                        ReactUserID,
                                        "Validate Purchase Domain",
                                        Requestdata,
                                        ""
                                   );
                              }
                         },
                         function OnError() {
                              setLoading(false);
                              utils.appInsightTrack(
                                   ReactBusinessId,
                                   ReactUserID,
                                   "Validate Purchase Domain",
                                   Requestdata,
                                   ""
                              );
                         }
                    );
               }
          }
          else {
               utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
          }
     }

     const ValidatePurchaseDomain = async () => {
          setLoading(true);
          const access_token = await useGenerateToken(dispatch);
          if (!IsModifyAllowed) {
               utils.ShowAlert("Message", "Sorry, You don't have permission to cancel auto renew domain.", "OpenDialog");
          }
          else {
               if (utils.Validate(access_token)) {
                    if (cartDomainList.length > 0) {
                         DoPayment(true);
                    }
                    else {
                         setLoading(false);
                    }
               }
               else {
                    setLoading(false);
                    utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
               }
          }
     }

     {
          isFirstTime === true && cartDomainList.length === 0 &&
               (window.location.href = "/business/" + params.StyleId + "/" + params.LayoutId + "/domain")
     }

     const ExistingCardSelection = async () => {
          if (!isExistingCard) {
               setshowcc(false)
               setisExistingCard(true);
          }
     }

     const NewCardSelection = async () => {
          if (isExistingCard) {
               setshowcc(true);
               setisExistingCard(false);
               GetCCIframe();
          }
     }

     return (
          <Fragment>
               {isLoading && <Loader />}
               <div className={ReactBusinessId <= 0 ? "all-content-container no-access-main-content-wrapper" : "all-content-container main-content-wrapper"}>
                    {!props.inEditor && <Leftpanel
                         activateTab={"GeneralSetting"}
                         activatePage={"Domain"}
                    />}
                    {(() => {
                         if (ReactBusinessId === 0 || typeof ReactBusinessId === 'undefined') {
                              return (
                                   <Fragment>
                                        <NoRights />
                                   </Fragment>
                              )
                         } else {
                              return (
                                   ReactBusinessId > 0 && (typeof cardTokenDetails.current != 'undefined' && cardTokenDetails.current != null && cardTokenDetails.current.merchantTokenID != null && cardTokenDetails.current.merchantTokenID != "") &&
                                   <Fragment>
                                        <div className="page-root">
                                             <div className="page-content container">
                                                  <div className="domain-checkout-wrapper">
                                                       {isFinish &&
                                                            <Alert isOpen={isFinish} variant={variant} className="vg-alert-strip vg-passive">
                                                                 <i class={`${variant == "danger" ? "far fa-times" : "fas fa-check-circle"}`}></i> {Message}
                                                            </Alert>
                                                       }
                                                       <div className="domain-section-title py-t16">
                                                            Checkout
                                                       </div>
                                                       {cartDomainList.length > 0 &&
                                                            <Fragment>
                                                                 <div className="domain-checkout-items">
                                                                      <div className="domain-section-title">
                                                                           Order Details
                                                                      </div>
                                                                      {cartDomainList.length > 0 && cartDomainList.map((d) => {
                                                                           return (
                                                                                <Fragment>
                                                                                     <div className="domain-checkout-item">
                                                                                          <div className="item-desc">
                                                                                               <span className="name">
                                                                                                    {d.domain}
                                                                                               </span>
                                                                                               <span className="expiry">
                                                                                                    Auto renews {d.renewDate}
                                                                                               </span>
                                                                                          </div>
                                                                                          <div className="item-price">
                                                                                               {d.currencySymbol + FormatPrice(d.vagaroDomainCharge)}/yr{" "}
                                                                                               <div>
                                                                                                    <a
                                                                                                         onClick={() => DeleteDomainCart(d.domain, true)}
                                                                                                         className="w-button w-button-ghost"
                                                                                                    >
                                                                                                         Remove
                                                                                                    </a>
                                                                                               </div>
                                                                                          </div>
                                                                                     </div>
                                                                                </Fragment>
                                                                           )
                                                                      })}
                                                                      <div className="domain-checkout-item subtotal-row">
                                                                           <div className="subtotal-row-item">
                                                                                <div className="item-desc">
                                                                                     <span className="name">
                                                                                          Subtotal
                                                                                     </span>
                                                                                </div>
                                                                                <div className="item-price">
                                                                                     {CurrencySymbol}{FormatPrice(subtotal)}
                                                                                </div>
                                                                           </div>
                                                                           <div className="subtotal-row-item tax-border-down">
                                                                                <div className="item-desc tax-row">
                                                                                     <span className="name">
                                                                                          Tax
                                                                                     </span>
                                                                                </div>
                                                                                <div className="item-price tax-price-editor">
                                                                                     {CurrencySymbol}{FormatPrice(taxamount)}
                                                                                </div>
                                                                           </div>
                                                                           <div className="subtotal-row-item">
                                                                                <div className="item-desc">
                                                                                     <span className="name">
                                                                                          Total
                                                                                     </span>
                                                                                </div>
                                                                                <div className="item-price">
                                                                                     {CurrencySymbol}{FormatPrice(totalamount)}
                                                                                </div>
                                                                           </div>
                                                                      </div>
                                                                 </div>
                                                                 <div className="domain-payment-wrapper">
                                                                      {typeof cardTokenDetails.current.cardTokenID != 'undefined' && cardTokenDetails.current.cardTokenID != null && cardTokenDetails.current.cardTokenID != "" &&
                                                                           <Fragment>
                                                                                <div className="domain-section-title">
                                                                                     Payment Details
                                                                                </div>
                                                                                <div className="domain-saved-payment">
                                                                                     <div className="domain-saved-payment-items">
                                                                                          <a href="javascript:void(0)"
                                                                                               className={!showcc ? "domain-saved-payment-item item-selected" : "domain-saved-payment-item"}
                                                                                               onClick={() => ExistingCardSelection()}
                                                                                          >{cardTokenDetails.current.creditCardType} ending in {cardTokenDetails.current.creditCardNumber}
                                                                                          </a>
                                                                                          <a href="javascript:void(0)"
                                                                                               className={showcc ? "domain-saved-payment-item item-selected" : "domain-saved-payment-item"}
                                                                                               onClick={(e) => NewCardSelection()}>
                                                                                               New Payment Method
                                                                                          </a>
                                                                                     </div>
                                                                                </div>
                                                                           </Fragment>
                                                                      }
                                                                      {showcc &&
                                                                           <div className="iframe-container">
                                                                                <div id="dvccframe"></div>
                                                                           </div>
                                                                      }
                                                                      <div className="domain-actions domain-payment-actions">
                                                                           <NavLink
                                                                                to={{ pathname: `${'/business/' + params.StyleId + "/" + params.LayoutId + "/searchdomain"}` }}
                                                                                className="w-button w-button-secondary"
                                                                           >
                                                                                Back
                                                                           </NavLink>
                                                                           <a
                                                                                onClick={(e) => { ValidatePurchaseDomain() }}
                                                                                className="w-button w-button-primary"
                                                                           >
                                                                                Buy Domain
                                                                           </a>
                                                                      </div>
                                                                 </div>
                                                            </Fragment>
                                                       }
                                                  </div>
                                             </div>
                                        </div>
                                   </Fragment>

                              )
                         }
                    })()}
               </div >
          </Fragment >
     );
};

export default Checkout;
